// for customer Dashbaord recent payments widget
export const GET_NOTICE_BOARD = "get_notice_board";
export const GET_NOTICE_BOARD_SUCCESS = "get_notice_board_success";
export const GET_NOTICE_BOARD_FAILURE = "get_notice_board_failure";
